import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='special-needs-planning-intro'
    themeType='lightTheme'
    backgroundVariant='lightA'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={<>Special skills for <WidowBlock>special needs.</WidowBlock></>}
    introContent={(
      <Typography disableBottomPadding>
        Making sure your loved one with special needs is taken care of is our Chartered Special Needs Consultants&#39; (ChSNC&#174;) specialty.<sup>1</sup> They&#39;ll answer the questions you have, and the ones you never knew you had&#8212;helping you design a plan so you can make informed decisions, know the right steps to take and when to take them, and provide the highest possible quality of life for your family.
      </Typography>
    )}
  />
);
